module.exports = ":host{display:flex;flex-direction:column;flex-grow:1}:host svg{width:100%}\n"